<template>
    <button :class="{'btn btn-mobile': true, 'mobile': !features.show_mobile_plus_btn_always}" @click="openSideForm()">
        <i class="icon icon-plus"></i>
    </button>
</template>

<script>
import { mapGetters } from 'vuex';
import { EventBus } from '../../event-bus'

export default {
    name: "MobilePlusBtn",

    props: ['type', 'data'],

    computed: {
        ...mapGetters(['features']),
    },

    methods: {
        openSideForm() {
            EventBus.$emit('open-side-form', this.type, this.data ? this.data : null);
        }
    },
}
</script>